
import Lottie, { AnimationItem } from 'lottie-web';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class LottieAnimation extends Vue {
  @Prop({ required: true }) animationData!: Record<string, unknown> | string;

  @Prop({ required: false, default: false }) loop!: boolean | number;

  @Prop({ required: false, default: true }) autoPlay!: boolean;

  @Prop({ required: false, default: 1 }) speed!: number;

  private anim: AnimationItem | null = null;

  mounted(): void {
    if (!this.$refs.animation) return;
    this.init();
  }

  beforeUnmount(): void {
    if (!this.anim) return;
    this.anim.destroy();
  }

  public init(): void {
    const container = this.$refs.animation;
    if (!container) return;

    this.anim = Lottie.loadAnimation({
      container: container as Element,
      renderer: 'svg',
      loop: this.loop,
      autoplay: this.autoPlay,
      animationData: JSON.parse(JSON.stringify(this.animationData)),
    });

    this.anim.addEventListener('loopComplete', () => {
      this.$emit('loopComplete', this.anim);
    });

    this.anim.addEventListener('complete', () => {
      this.$emit('complete', this.anim);
    });

    this.anim.addEventListener('enterFrame', () => {
      this.$emit('enterFrame', this.anim);
    });
  }

  public play(): void {
    if (this.anim) { this.anim.play(); }
  }

  public stop(): void {
    if (this.anim) { this.anim.stop(); }
  }

  public pause(): void {
    if (this.anim) { this.anim.pause(); }
  }
}
